import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StepperService {
    public currentListStep: string[];
    public currentStep: string;
    public currentStepNb: number;
    private readonly listStepSubject: BehaviorSubject<string[]> = new BehaviorSubject(null);
    private readonly listStep = this.listStepSubject.asObservable();

    constructor() {
        const stepResult = this.listStep.subscribe({
            next: listStep => this.currentListStep = listStep,
            complete: () => {
                if (stepResult) {
                    stepResult.unsubscribe();
                }
            }
        });
    }

    setListStep(listStep: string[]) {
        this.listStepSubject.next(listStep);
    }

    initOrClear() {
        this.currentStepNb = 0;
        this.currentStep = this.currentListStep[this.currentStepNb];
    }

    nextPage() {
        if (this.currentStepNb <= this.currentListStep.findIndex(step => step === this.currentStep)) {
            this.currentStepNb++;
            this.currentStep = this.currentListStep[this.currentStepNb];
        }
    }

    previousPage() {
        if (this.currentStepNb > 0) {
            this.currentStepNb--;
            this.currentStep = this.currentListStep[this.currentStepNb];
        }
    }
}
